import {Component, Input, OnInit, Output} from '@angular/core';
import {
  fdeBloombergNavObject
} from "../../../../../common/it-interface";
import {convertToSnakeCase} from "../../../../../common/it-utils";
import {SIDE_NAV_TITLES} from "../../../../../common/it-constants";

@Component({
  selector: 'app-bbg-nav-table',
  templateUrl: './bbg-nav-table.component.html',
  styleUrls: ['./bbg-nav-table.component.scss']
})
export class BbgNavTableComponent implements OnInit {

  @Input() tableDataShow: string;
  @Input() listOfFdeBbgNavByHstDate: fdeBloombergNavObject[];
  @Input() subLoading: boolean;

  fundDayEndReportKey = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);

  constructor() {}

  ngOnInit() {
    this.listOfFdeBbgNavByHstDate = [];
  }

}
